/**
 * Decorator for $uibModal that automatically adds/removes the 'modal-open'
 * class on the app root element for fullscreen modals.
 */
const configUibModalDecorator = $provide => {
	'ngInject';
	$provide.decorator('$uibModal', ($delegate, $injector) => {
		'ngInject';
		const originalOpen = $delegate.open;
		$delegate.open = function (options) {
			const modalInstance = originalOpen.call(this, options);
			if (options.size?.includes('fullscreen')) {
				const DOMHelpersSvc = $injector.get('DOMHelpersSvc');
				const body = DOMHelpersSvc.getById('ocaApp');
				body.classList.add('modal-open');
				modalInstance.result
					.then(() => {})
					.catch(() => {})
					.finally(() => {
						body.classList.remove('modal-open');
					});
			}
			return modalInstance;
		};
		return $delegate;
	});
};
export default configUibModalDecorator;
